module.exports = __webpack_public_path__ + "img/DAY4-3.fcc604d3.jpg";